var _path, _ellipse, _ellipse2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPulseLine1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 190,
    viewBox: "0 0 345 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 38.5C179 5 164 172.5 344 188",
    stroke: "#F4F5FA",
    strokeWidth: 4,
    strokeDasharray: "16 16"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 44.5,
    cy: 44.3639,
    rx: 44.5,
    ry: 44.3639,
    fill: "url(#paint0_radial_1195_115851)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 44.5005,
    cy: 44.3644,
    rx: 26.7,
    ry: 26.6183,
    fill: "url(#paint1_radial_1195_115851)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44.5725,
    r: 7,
    fill: "#FFB801"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1195_115851",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5 44.3639) rotate(90) scale(67.5541 67.7614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB301",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECB301"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1195_115851",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5005 44.3644) rotate(90) scale(40.5325 40.6568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB301",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECB301"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPulseLine1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pulse-line-1.b1df93a4ac4236c93f09940201eda1ab.svg";